import initAegis from './tx-cloud'

export default function setupMonitor() {
  initAegis()
}
